export enum MessageTypeEnum {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
}
export interface MessageType {
  messageType: MessageTypeEnum;
  message: string;
}
